import { render } from "./CookieWarning.vue?vue&type=template&id=b3bbb856"
import script from "./CookieWarning.vue?vue&type=script&lang=js"
export * from "./CookieWarning.vue?vue&type=script&lang=js"

import "./CookieWarning.vue?vue&type=style&index=0&id=b3bbb856&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__